import BaseIconButton from '@material-ui/core/IconButton'

const IconButton = BaseIconButton

export default IconButton
